//
//
//
//
//
//

export default {
  name: "ResidentReports",
  data: function data() {
    var $el = this;
    return {
      reports: [{
        reportId: "INSURANCE_REPORT",
        reportType: "Insurance Report",
        reportComponent: "insurance-report",
        reportTable: "residents"
      }, {
        reportId: "LEAD_TO_LEASE_SOURCE",
        reportType: "Lead To Lease - Source",
        reportComponent: "lead-to-lease-source",
        reportTable: "residents"
      }, {
        reportId: "LEAD_TO_LEASE_USER",
        reportType: "Lead To Lease - User",
        reportComponent: "lead-to-lease-user",
        reportTable: "residents"
      }, {
        reportId: "LEASE_EXPIRATION_REPORT",
        reportType: "Lease Expiration Report",
        reportComponent: "lease-expiration-report",
        reportTable: "residents"
      }, {
        reportId: "LEASE_TO_LEASE_REPORT",
        reportType: "Lease To Lease Report",
        reportComponent: "lease-to-lease-report",
        reportTable: "units"
      }, {
        reportId: "MONTH_TO_MONTH",
        reportType: "Month To Month",
        reportComponent: "month-to-month",
        reportTable: "residents"
      }, {
        reportId: "MOVE_IN_REPORT",
        reportType: "Move In Report",
        reportComponent: "move-in-report",
        reportTable: "residents"
      }, {
        reportId: "MOVE_OUT_REPORT",
        reportType: "Move Out Report",
        reportComponent: "move-out-report",
        reportTable: "residents"
      }, {
        reportId: "OCCUPANCY_REPORT",
        reportType: "Occupancy By Unit Type",
        reportComponent: "occupancy-report",
        reportTable: "units"
      }, {
        reportId: "ONLINE_PAYMENT_REPORT",
        reportType: "Online Payment Report",
        reportComponent: "online-payment-report",
        reportTable: "residents"
      }, {
        reportId: "PET_REPORT",
        reportType: "Pet Report",
        reportComponent: "resident-pet-report",
        reportTable: "resident_pets"
      }, {
        reportId: "PRICING_SHEET",
        reportType: "Pricing Sheet",
        reportComponent: "pricing-sheet",
        reportTable: "units"
      }, {
        reportId: "NEW_RENT_ROLL",
        reportType: "Rent Roll Report",
        reportComponent: "new-rent-roll",
        reportTable: "units"
      }, {
        reportId: "RENEWALS_REPORT",
        reportType: "Renewals Report",
        reportComponent: "renewals-report",
        reportTable: "units"
      }, {
        reportId: "RESIDENT_CONTACT_INFO",
        reportType: "Resident Contact Info",
        reportComponent: "resident-contact-info",
        reportTable: "residents"
      }, {
        reportId: "SERVICE_REQUEST_REPORT",
        reportType: "Service Request Report",
        reportComponent: "service-request-report",
        reportTable: "units"
      }, {
        reportId: "UNIT_AMENITY_LIST",
        reportType: "Unit Amenity List",
        reportComponent: "unit-amenity-list",
        reportTable: "units"
      }, {
        reportId: "UNIT_AVAILABILITY",
        reportType: "Unit Availability",
        reportComponent: "unit-availability",
        reportTable: "units"
      }]
    };
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/ResidentReports.vue
// module id = /bpe
// module chunks = 0 1